import { Brick, registerBrick } from 'olympe';
import {performGetFromJSON, processResults} from './helpers';
import {getLogger} from '@olympeio/core';

export default class GetFromJSONCustom extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {string} path
     * @param {function()} forwardEvent
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    update($, [source, path], [forwardEvent, setResult, setErrorFlow]) {
        const logger = getLogger('Get From JSON');

        // Guards
        if (typeof source !== 'object' && typeof source !== 'string') {
            logger.error('Provided source is not object or string');
            return;
        }
        if (typeof path !== 'string') {
            logger.error('Provided path is not a string');
            return;
        }

        performGetFromJSON(source, path, setErrorFlow, (results) => {
            processResults(results, logger, (res) => {
                setResult(res);
                forwardEvent();
            });
        });
    }
}

registerBrick('018a2135bdb19cf89f07', GetFromJSONCustom);
